import {
  Component
} from '@angular/core';

@Component({
  selector: 'zeiss-panel',
  templateUrl: './zeiss-panel.html'
})
export class ZeissPanelComponent {

  constructor( ) { }

}



// WEBPACK FOOTER //
// ./src/components/zeiss-panel/zeiss-panel.component.ts